module.exports = __webpack_public_path__ + "img/full-image-watermark-original.462226c5.webp";